export default __webpack_public_path__ + "static/media/eye-open.07baab73.svg";